import { render, staticRenderFns } from "./Reporteventap.vue?vue&type=template&id=706f4a03&"
import script from "./Reporteventap.vue?vue&type=script&lang=js&"
export * from "./Reporteventap.vue?vue&type=script&lang=js&"
import style0 from "./Reporteventap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports